export const FETCH_SOCIAL_REQUEST = 'FETCH_SOCIAL_REQUEST'
export const FETCH_SOCIAL_SUCCES = 'FETCH_SOCIAL_SUCCES'
export const FETCH_SOCIAL_ERROR = 'FETCH_SOCIAL_ERROR'



// WEBPACK FOOTER //
// ./src/constants/Social.js